<script>
  import SvelteMarkdown from 'svelte-markdown';
  import Container from './Container.svelte';
  import Editor from './Editor.svelte';

  import * as components from '../components.js';

  export let user;
  export let source;
  export let style = '';

  export let sections = [];
  let rawSections = [];


  const addSection = (position, scrollPosition, name, depth) => {
    if (position == 0 && sections.length > 0) {
      rawSections = [];
      sections = [];
    }
    rawSections[position] = {name, scrollPosition, depth};
    sections = rawSections.filter(x => x);
  }
  let containers = []

  const onParsed = (position, tokens) => {
    let aux = tokens[0].raw.slice(0,4);
    if (tokens[0].type === 'heading' && (aux.match(/#/g)||[]).length <= 2) {
      // check that it is a heading and it is a # o ## heading
      addSection(position, containers[position].offsetTop, tokens[0].text, tokens[0].depth)
    }
  }

</script>

{#each source.filter(x => !x.metadata.tags?.includes('hidden')) as cell, position}
  {#if cell.cell_type === 'raw'}
    {#if cell.metadata.tags?.filter(x => x.slice(0, 'component:'.length) === 'component:')}
      <svelte:component this={components[cell.metadata.tags.filter(x => x.slice(0, 'component:'.length) === 'component:')[0].slice('component:'.length)]} 
        user={user}  
        {...JSON.parse(cell.source)}/>
    {/if}
  {:else}
    <Container style={style}>
      <div id="markdown-container" style={
        cell.metadata.tags?.includes('class:Right')? 
      cell.metadata.tags?.includes('class:Right')? 
        cell.metadata.tags?.includes('class:Right')? 
          'width: 90%; float: right;' : 
        'width: 90%; float: right;' : 
          'width: 90%; float: right;' : 
            cell.metadata.tags?.includes('class:Left')?
              'width: 90%; float: left;' :
              cell.metadata.tags?.includes('class:Center')?
                'width: 90%; margin: 0 auto;':
                  ''} bind:this={containers[position]}>
        {#if cell.cell_type === 'markdown'}
          <div class="text">
            <SvelteMarkdown source={cell.source.join('')} on:parsed={e => onParsed(position, e.detail.tokens)}/>
          </div>
        {:else if cell.cell_type === 'code'}
          {#if cell.source.length}
            <Editor 
              language={
                cell.metadata.tags?.includes('language:null') ? 'null' :
                  cell.metadata.tags?.includes('language:javascript')? 'javascript' :
                  "python"}
              data={cell.source.join('')} readOnly={true}/>
          {/if}
          {#each cell.outputs as output}
            {#if output.output_type === 'stream'}
              <Editor language="null" data={output.text?.join('').replaceAll('\u001b[92m≈\u001b[0m', '≈')} readOnly={true} 
              backgroundColor={"transparent"} border={false}/>
            {:else if output.output_type === 'error'}
              <Editor language="null" data={output.evalue?.replaceAll('\u001b[92m≈\u001b[0m', '≈')} readOnly={true} 
              backgroundColor={"#fcc"} border={false}/>
            {/if}
          {/each}
        {/if}
      </div>
    </Container>
  {/if}
{/each}

<style>
  :global(div) {
    font-size: medium;
  }
  .text {
    /* max-width: 800px; */
    margin: 0 auto;
    text-align: justify;
    line-height: 200%;
  }
  .text :global(strong) {
    color: var(--secondary);
  }
  .text :global(h3) {
    font-weight: 400;
  }

</style>